import { usePopupMenu } from '@providers/mobile-popup-menu'

import { View } from './view'

export const PopupMenuComponentV2 = ({ enabled }) => {
	const popupMenu = usePopupMenu()

	return View({
		enabled,
		onClose: () => popupMenu.setVisibleStatus(false),
	})
}
